import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { Lang, translations } from '../data/i18n';
interface LanguageContextValue {
  lang: Lang;
  setLang: (lang: Lang) => void;
  toggleLang: () => void;
  t: (key: string) => string;
}
const LanguageContext = createContext<LanguageContextValue | null>(null);
interface LanguageProviderProps {
  initialLang?: Lang;
  children: React.ReactNode;
}
export function LanguageProvider({
  initialLang = 'en',
  children
}: LanguageProviderProps) {
  const [lang, setLang] = useState<Lang>(initialLang);
  const t = useCallback((key: string) => translations[lang][key] ?? translations.en[key] ?? key, [lang]);
  const value = useMemo<LanguageContextValue>(() => ({
    lang,
    setLang,
    toggleLang: () => setLang(prev => prev === 'en' ? 'es' : 'en'),
    t
  }), [lang, t]);
  return <LanguageContext.Provider value={value} data-id="element-332" data-mp="2jl8a5hgkavcn">{children}</LanguageContext.Provider>;
}
export function useLanguage(): LanguageContextValue {
  const ctx = useContext(LanguageContext);
  if (!ctx) {
    throw new Error('useLanguage must be used inside a LanguageProvider');
  }
  return ctx;
}